import { jsxs as b, Fragment as xe, jsx as a } from "react/jsx-runtime";
import { useState as g, useEffect as et } from "react";
import { getActiveCart as ve, OrderType as re, isMainCart as Ne, isGroupOrder as ut, isProxyOrder as Je, switchCartNewStrategy as ht, SWITCH_PROXY_TYPE as ft, switchCart as gt, updateCart as Ce, switchOrOverrideCart as Ct, updateShippingAddressInLS as Ue, PublishEvent as pt, CartEventsEnum as oe, myListApi as ie, ApiProjections as Pe, ListType as Ae, isProductInWishlist as Ze, hideBV as bt, CartRoutePaths as Me, ListExceptionDetail as yt, getFilteredEntries as He, validateBundleInEntries as De, updateListsByUser as Ge, productEntryData as Tt, PublishWishlistEvent as kt, showEditLabel as St, cartApi as _e, CartConstantsEnum as M, CartEvents as Le, updateMyList as _t, getWishlist as Lt } from "@commerce-cart-webcomponents/sdk";
import { useTranslation as Fe, useNextgenRouter as Ye, FAIcon as ze, useSession as tt, Drawer as It, TextLink as at, Theme as wt, TextLinkStyle as rt, CardCheckbox as Vt, Button as Ve, ButtonStyles as ot, ButtonWidth as Re, Menu as xt, Modal as zt } from "@nextgen-web-framework/all";
import { ConfigService as Et, StorageService as O } from "@nextgen-web-framework/core";
import { useSelector as We, useDispatch as je } from "react-redux";
import { useAddressUpdate as it } from "@commerce-webcomponents/ui";
import { useCartNotification as Ke } from "./common/hooks/useCartNotification.js";
import { CartNotificationTheme as G } from "./common/components/cart-notification/types/enums.js";
import { TOAST_TIMEOUT as W } from "./common/types/enums.js";
import { GCOProductCard as $t } from "@commerce-product-webcomponents/ui";
import { CreateList as vt } from "./components/lists/components/create-list/CreateList.js";
import { FrameRectangle as st } from "./common/components/cart-loader/frame-rectangle/FrameRectangle.js";
import { CircleLoader as Pt } from "./common/components/cart-loader/circle-loader/CircleLoader.js";
import { AccountSearchDrawer as qe } from "./common/components/account-search-drawer/AccountSearchDrawer.js";
import { ItemsUnavailable as Bt } from "./components/cart-total/items-unavailable/ItemsUnavailable.js";
import "./common/CustomListContext.js";
import "./utils/cmsApiCall.js";
import { useExceptionToast as nt } from "./common/hooks/useExceptionToast.js";
import "./common/components/cart-notification/CartNotification.js";
import "./EllipsisMenu.module-62573c8a.mjs";
import "./FrameRectangle.module-a1e153e3.mjs";
import "./OrderSummaryLoader.module-25035cd2.mjs";
import "./GCOLoader.module-cbefdd07.mjs";
import "./NormalLoader.module-9680b666.mjs";
import "./ButtonLoader.module-dbd7d833.mjs";
import "./DownlineSearchLoader.module-81caeeee.mjs";
import { ModalWrapper as Ot } from "./common/components/modal-wrapper/ModalWrapper.js";
import "./DynamicBundleDrawer.module-0114c7f0.mjs";
import { CART_ELLIPSIS_ID as Ie } from "./components/cart-ellipsis-menu/types/enums.js";
import { v as At } from "./cartCommonHelpers-79628e81.mjs";
import "./CircleLoader.module-a231deef.mjs";
import "./ModalWrapper.module-fb179420.mjs";
import { useFeatureFlag as Rt } from "./common/hooks/useFeatureFlag.js";
import { AddToListImageLoader as Nt } from "./components/lists/components/list-loaders/add-to-list-image-loader/AddToListImageLoader.js";
import { ButtonLoader as Ut } from "./common/components/cart-loader/button-loader/ButtonLoader.js";
import { useIntersectionObserver as Mt } from "./hooks/useIntersectionObserver.js";
import { AddToListDrawerLoader as Ht } from "./components/lists/components/add-to-list-drawer/add-to-list-drawer-loader/AddToListDrawerLoader.js";
import './assets/CartEllipsisMenu.css';const Gt = "#ffffff", Wt = "#396e75", qt = "#e5fdff", Ft = "#546223", Yt = "#f0fae5", jt = "#a65523", Kt = "#fff1e8", Xt = "#7f3e3e", Qt = "#ffe2e2", Jt = "#62625a", Zt = "#f8f8e7", Dt = "#38539a", ea = "#707070", ta = "#c8f8d1", aa = "#87c9c8", ra = "#5291b1", oa = "rgba(82, 145, 177, 0.1019607843)", ia = "#445685", sa = "#181d61", na = "rgba(24, 29, 97, 0.1019607843)", ca = "#5969d6", la = "#ea999d", da = "#b6577e", ma = "rgba(182, 87, 126, 0.1019607843)", ua = "#7e3e80", ha = "#1e247f", fa = "rgba(30, 36, 127, 0.1019607843)", ga = "#da7600", Ca = "#107f47", pa = "#d91734", ba = "_html_1lbxq_46", T = {
  amwayWhite: Gt,
  darkBlue: Wt,
  lightBlue: qt,
  darkGreen: Ft,
  lightGreen: Yt,
  darkOrange: jt,
  lightOrange: Kt,
  darkRed: Xt,
  lightRed: Qt,
  darkYellow: Jt,
  lightYellow: Zt,
  darkPurple: Dt,
  darkGrayOnWhite: ea,
  dataVizColor1: ta,
  dataVizColor2: aa,
  dataVizColor3: ra,
  dataVizColor3Background: oa,
  dataVizColor4: ia,
  dataVizColor5: sa,
  dataVizColor5Background: na,
  dataVizColor6: ca,
  dataVizColor7: la,
  dataVizColor8: da,
  dataVizColor8Background: ma,
  dataVizColor9: ua,
  dataVizColor10: ha,
  dataVizColor10Background: fa,
  dataVizAlertOrange: ga,
  dataVizSuccessGreen: Ca,
  dataVizWarningRed: pa,
  "no-visible": "_no-visible_1lbxq_42",
  html: ba,
  "commerce-header-total-sec": "_commerce-header-total-sec_1lbxq_80",
  "commerce-header-total": "_commerce-header-total_1lbxq_80",
  "hide-desktop": "_hide-desktop_1lbxq_90",
  "child-cart": "_child-cart_1lbxq_93",
  "commerce-header-back": "_commerce-header-back_1lbxq_93",
  "commerce-header-back-with-title": "_commerce-header-back-with-title_1lbxq_96",
  "commerce-header-total-subcart-text": "_commerce-header-total-subcart-text_1lbxq_103",
  "commerce-header-total-text": "_commerce-header-total-text_1lbxq_106",
  "commerce-header-total-text-scrolled": "_commerce-header-total-text-scrolled_1lbxq_112",
  "commerce-header-total-text-listDrawer": "_commerce-header-total-text-listDrawer_1lbxq_118",
  "commerce-header-total-count": "_commerce-header-total-count_1lbxq_124",
  "commerce-header-total-count-seperator": "_commerce-header-total-count-seperator_1lbxq_130",
  "downline-header": "_downline-header_1lbxq_134",
  "downline-header-name": "_downline-header-name_1lbxq_141",
  "downline-header-icon": "_downline-header-icon_1lbxq_145",
  "commerce-header-ellipsis-wrapper": "_commerce-header-ellipsis-wrapper_1lbxq_150",
  "skeleton-loading": "_skeleton-loading_1lbxq_1"
}, ya = ({ isScrolled: m = !1, isGCOList: A = !1, isListDrawer: k }) => {
  var me;
  const e = Fe(), { cartOverrideFlag: se } = Rt(), { updateAddress: K } = it(), X = Ye(), $ = ((me = X.params) == null ? void 0 : me.cartId) ?? "", h = We((o) => o.commerceCart), ne = je(), [pe, z] = g(!1), [be, ce] = g(), { isLoading: ye, cart: l } = h, i = ve(l, String($)), r = $ || l.orderType !== re.Gco ? i : l, { createToast: Q, deleteToast: I } = Ke("cartTypeSelectionDrawer"), Te = e("cart.cartTypeSelectionDrawer.drawerHeader"), v = e("cart.cartTypeSelectionDrawer.inputPlaceHolder"), J = e("cart.cartTypeSelectionDrawer.primaryButtonText"), S = e("cart.cartTypeSelectionDrawer.secondaryButtonText"), ke = e("cart.cartTypeSelectionDrawer.subHeading"), Z = e("cart.cartTypeSelectionDrawer.cartChanged"), q = e("cart.cartTypeSelectionDrawer.cartChangedHeading"), E = () => Q(
    {
      theme: G.SUCCESS,
      rightSeperator: !1,
      content: q,
      subtext: Z,
      clickIcon: "times",
      icon: "check-circle",
      timeOut: W
    },
    I
  ), _ = () => {
    var o, u, w;
    return Ne(i == null ? void 0 : i.subCartId) ? e(A ? "cart.cartLineitems.carts" : "cart.cartLineitems.cartTotalText") : `${((o = i == null ? void 0 : i.amwayUser) == null ? void 0 : o.firstName) ?? ""} ${((u = i == null ? void 0 : i.amwayUser) == null ? void 0 : u.lastName) ?? ""} (${(w = i == null ? void 0 : i.amwayUser) == null ? void 0 : w.accountId})`;
  }, F = () => {
    const { primaryName: o = "" } = (i == null ? void 0 : i.amwayUser) || {}, u = "DownLine", w = !o;
    switch (l.orderType) {
      case re.Regular:
        return e("cart.cartLineitems.cartTotalText");
      case re.Proxy:
        return /* @__PURE__ */ b("div", { className: T["downline-header"], children: [
          /* @__PURE__ */ b("div", { className: T["downline-header-name"], children: [
            o,
            " ",
            w && u
          ] }),
          /* @__PURE__ */ a(
            ze,
            {
              className: T["downline-header-icon"],
              onClick: () => z(!0),
              iconName: "chevron-down"
            }
          )
        ] });
      case re.Gco:
        return _();
      default:
        return "";
    }
  }, x = (o, u) => Number(r == null ? void 0 : r.totalEntries) > 1 ? o : u, R = (o) => {
    const u = l.subCarts.length > 1;
    return $ ? o ? "cart.cartMobileHeader.pluralItems" : "cart.cartMobileHeader.items" : u && o ? "cart.cartMobileHeader.pluralItemInCarts" : u ? "cart.cartMobileHeader.pluralItemsInCart" : o ? "cart.cartMobileHeader.pluralItemInCart" : "cart.cartMobileHeader.itemInCart";
  }, Se = () => {
    var w, B;
    let o = "";
    const u = Number(r == null ? void 0 : r.totalEntries) > 1;
    if (ut(l.orderType))
      o = R(u);
    else if (Je(l.orderType)) {
      const Y = x(
        e("cart.cartMobileHeader.pluralListItems"),
        e("cart.cartMobileHeader.listItems")
      );
      return /* @__PURE__ */ b(xe, { children: [
        "(",
        (w = i == null ? void 0 : i.amwayUser) == null ? void 0 : w.accountId,
        " ",
        /* @__PURE__ */ a("span", { className: T["commerce-header-total-count-seperator"], children: "•" }),
        " ",
        Y.replace(/{{itemCount}}/g, String(i.totalEntries)),
        ")"
      ] });
    } else
      o = x("cart.cartMobileHeader.pluralItems", "cart.cartMobileHeader.items");
    return k && (o = x("cart.cartMobileHeader.pluralListItems", "cart.cartMobileHeader.listItems")), e(o).replace(/{{itemCount}}/g, String((r == null ? void 0 : r.totalEntries) ?? 0)).replace(/{{cartCount}}/g, String((B = l == null ? void 0 : l.subCarts) == null ? void 0 : B.length));
  }, f = () => m ? T["commerce-header-total-text-scrolled"] : k ? T["commerce-header-total-text-listDrawer"] : T["commerce-header-total-text"], N = (o, u = "") => /* @__PURE__ */ a("div", { role: "presentation", className: `${u}`, onClick: o, "data-testId": "back-icon", children: /* @__PURE__ */ a(ze, { iconName: "chevron-left" }) }), L = () => {
    var o;
    return !A && l.orderType === re.Gco && ((o = i == null ? void 0 : i.entries) == null ? void 0 : o.length) === 0 && i.subCartId !== l.id;
  }, le = async (o) => {
    if (se && !ht()) {
      de(ft.OVERRIDE, o);
      return;
    }
    ce(o);
    const u = await gt(l, re.Proxy, o);
    ne(Ce(u)), z(!1), E();
  }, de = async (o, u) => {
    var ue, D, ee, he;
    const w = l.orderType, B = await Ct(
      ve(l),
      u ?? be,
      o
    );
    z(!1), ne(Ce(B));
    const Y = ve(B), j = await Ue(
      (ue = Y.amwayUser) == null ? void 0 : ue.amwayUserId,
      (D = Y.amwayUser) == null ? void 0 : D.accountId
    );
    Je(w) && (j === null || !(j != null && j.contacts.length)) && await Ue((ee = l.amwayUser) == null ? void 0 : ee.amwayUserId, (he = l.amwayUser) == null ? void 0 : he.accountId), K(), pt({
      cartEvent: oe.UpdateMiniCartIcon,
      cart: B
    }), E();
  };
  return /* @__PURE__ */ b(xe, { children: [
    pe && /* @__PURE__ */ a(
      qe,
      {
        modalConfirmClick: de,
        showSwitchModal: !0,
        showDisableCards: !0,
        drawerHeaderTitle: Te,
        placeHolderText: v,
        primaryButtonText: J,
        secondaryButtonText: S,
        subHeading: ke,
        showActiveCart: !0,
        onRadioChange: le,
        onPrimaryButtonClick: () => z(!1),
        cartData: l,
        onClose: () => z(!1)
      }
    ),
    ye ? /* @__PURE__ */ a(st, { width: "146", height: "48", borderRadius: "8" }) : /* @__PURE__ */ b("div", { className: `${T["commerce-header-total-sec"]} ${$ ? T["child-cart"] : ""}`, children: [
      /* @__PURE__ */ b("div", { className: `${T["commerce-header-total"]} ${$ ? T["child-cart"] : ""}`, children: [
        $ ? N(() => X.back(), T["commerce-header-back"]) : "",
        /* @__PURE__ */ b("div", { className: T["commerce-header-back-with-title"], children: [
          !$ && N(() => X.back(), T["hide-desktop"]),
          /* @__PURE__ */ b("div", { children: [
            /* @__PURE__ */ a(
              "div",
              {
                className: `${f()}
          ${!Ne(i == null ? void 0 : i.subCartId) && T["commerce-header-total-subcart-text"]}
          `,
                "data-testid": "cart-title-test-id",
                "data-pod-name": "cart",
                children: F()
              }
            ),
            /* @__PURE__ */ a("div", { className: T["commerce-header-total-count"], children: Se() })
          ] })
        ] })
      ] }),
      L() && /* @__PURE__ */ a("div", { className: T["commerce-header-ellipsis-wrapper"], children: /* @__PURE__ */ a(zr, { currentCartId: i == null ? void 0 : i.subCartId }) })
    ] })
  ] });
}, Ta = "#ffffff", ka = "#396e75", Sa = "#e5fdff", _a = "#546223", La = "#f0fae5", Ia = "#a65523", wa = "#fff1e8", Va = "#7f3e3e", xa = "#ffe2e2", za = "#62625a", Ea = "#f8f8e7", $a = "#38539a", va = "#707070", Pa = "#c8f8d1", Ba = "#87c9c8", Oa = "#5291b1", Aa = "rgba(82, 145, 177, 0.1019607843)", Ra = "#445685", Na = "#181d61", Ua = "rgba(24, 29, 97, 0.1019607843)", Ma = "#5969d6", Ha = "#ea999d", Ga = "#b6577e", Wa = "rgba(182, 87, 126, 0.1019607843)", qa = "#7e3e80", Fa = "#1e247f", Ya = "rgba(30, 36, 127, 0.1019607843)", ja = "#da7600", Ka = "#107f47", Xa = "#d91734", Qa = "_html_173ya_46", H = {
  amwayWhite: Ta,
  darkBlue: ka,
  lightBlue: Sa,
  darkGreen: _a,
  lightGreen: La,
  darkOrange: Ia,
  lightOrange: wa,
  darkRed: Va,
  lightRed: xa,
  darkYellow: za,
  lightYellow: Ea,
  darkPurple: $a,
  darkGrayOnWhite: va,
  dataVizColor1: Pa,
  dataVizColor2: Ba,
  dataVizColor3: Oa,
  dataVizColor3Background: Aa,
  dataVizColor4: Ra,
  dataVizColor5: Na,
  dataVizColor5Background: Ua,
  dataVizColor6: Ma,
  dataVizColor7: Ha,
  dataVizColor8: Ga,
  dataVizColor8Background: Wa,
  dataVizColor9: qa,
  dataVizColor10: Fa,
  dataVizColor10Background: Ya,
  dataVizAlertOrange: ja,
  dataVizSuccessGreen: Ka,
  dataVizWarningRed: Xa,
  "no-visible": "_no-visible_173ya_42",
  html: Qa,
  "list-container": "_list-container_173ya_80",
  "list-container-title": "_list-container-title_173ya_84",
  "list-container-cardCheckbox": "_list-container-cardCheckbox_173ya_94",
  "list-privacy": "_list-privacy_173ya_97",
  "list-container-myShop": "_list-container-myShop_173ya_104",
  "list-container-myShop-private-text": "_list-container-myShop-private-text_173ya_107",
  "create-list-footer-button": "_create-list-footer-button_173ya_127",
  "create-list-footer-button-confirm-loader": "_create-list-footer-button-confirm-loader_173ya_132",
  "create-list-footer-button-loader": "_create-list-footer-button-loader_173ya_135",
  "skeleton-loading": "_skeleton-loading_173ya_1"
}, Ja = ({
  onDrawerClose: m,
  heartIconFilledcb: A,
  isMyShop: k,
  productData: e,
  cartEntriesDetails: se,
  fetchMyShopListsCB: K,
  bundleSlots: X = [],
  showCreateListForm: $ = !1
}) => {
  var Ee, $e;
  const h = Fe(), ne = je(), pe = Ye(), { isABO: z, isRegistered: be } = tt(), ye = Et.getConfigs().NEXT_ASSETS_BASE_PATH, [l, i] = g($), [r, Q] = g({
    lists: []
  }), [I, Te] = g({
    entries: [],
    name: "",
    description: "",
    category: ""
  }), [v, J] = g([]), [S, ke] = g(!0), [Z, q] = g(!1), E = h("cart.addToListToggle.ProductAddedToWishlist"), _ = h("cart.addToListToggle.ProductAddedToList"), F = h("cart.myshop.changesSaved"), { createToast: x, deleteToast: R } = Ke("addToList"), Se = h("cart.createList.maxLimitReached"), f = h("cart.myshop.listCreated"), N = h("cart.createList.pleaseDeleteToCreateNew"), [L, le] = g(0), [de, me] = g(), o = nt();
  et(() => {
    ie.getListsByUser({
      projections: Pe.DETAILED,
      page: L.toString()
    }).then((t) => {
      var d;
      const s = L != 0 ? [...r.lists || [], ...t.lists || []] : t.lists;
      if (L != 0 ? Q((C) => ({
        ...C,
        lists: [...(C == null ? void 0 : C.lists) || [], ...(t == null ? void 0 : t.lists) || []]
      })) : Q(t), k) {
        const C = ((d = s == null ? void 0 : s.filter((c) => c.isDisplayedOnShop)) == null ? void 0 : d.map((c) => (c == null ? void 0 : c.listId) ?? "")) ?? [];
        J(C ?? []);
      }
    }).catch((...t) => o(t)).finally(() => ke(!1));
  }, [L]), Mt(
    de,
    { rootMargin: "1px" },
    () => {
      r != null && r.lists && (r == null ? void 0 : r.listCount) !== void 0 && (r == null ? void 0 : r.lists.length) < (r == null ? void 0 : r.listCount) && le(L + 1);
    },
    [((Ee = r == null ? void 0 : r.lists) == null ? void 0 : Ee.length) ?? 0]
  );
  const u = () => {
    var s;
    const t = [];
    (s = r.lists) == null || s.forEach((d) => {
      d.listId && t.push({
        ...d,
        ...d.payLoad,
        isDisplayedOnShop: v.includes(d.listId)
      });
    }), t != null && t.length && (q(!0), ie.updateList(t).then(() => {
      x(
        {
          theme: G.SUCCESS,
          rightSeperator: !1,
          content: F,
          clickIcon: "times",
          icon: "check-circle",
          timeOut: W
        },
        R
      );
    }).catch((...d) => o(d)).finally(() => {
      m == null || m(), K == null || K(), q(!1);
    }));
  }, w = () => {
    q(!0);
    const t = [
      {
        product: {
          id: e == null ? void 0 : e.productId
        },
        quantity: 1,
        bundleSlots: X
      }
    ], s = He(se || [], {
      filterPromotion: !1,
      filterSOP: !1,
      filterIsAccountFeeProduct: !0,
      filterIsAccountKitProduct: !0,
      filterUnsellableProduct: !0,
      filterAuxiliaryProducts: !0
    }), d = De(
      s == null ? void 0 : s.map((c) => ({
        product: {
          id: c == null ? void 0 : c.product.id
        },
        quantity: (c == null ? void 0 : c.quantity) || 1,
        bundleId: "",
        bundleSlots: c.bundleSlots ?? []
      }))
    ), C = v.map((c) => {
      var U, P;
      return {
        version: (P = (U = r == null ? void 0 : r.lists) == null ? void 0 : U.find((fe) => fe.listId === c)) == null ? void 0 : P.version,
        listId: c,
        entries: e ? De(t) : d
      };
    });
    ie.addToList(C).then((c) => {
      m == null || m(), ie.getAllListByUser({
        projections: Pe.FULL
      }).then((P) => ne(Ge(P))).catch((...P) => o(P)), A == null || A(!0);
      const U = Tt(c, (e == null ? void 0 : e.productId) || "");
      kt({
        cartEvent: oe.AddToWishlist,
        listEntry: U
      }), x(
        {
          theme: G.SUCCESS,
          rightSeperator: !1,
          content: be() ? E : _,
          clickIcon: "times",
          icon: "check-circle",
          timeOut: W
        },
        R
      );
    }).catch(() => {
      o();
    }).finally(() => q(!1));
  }, B = (t) => {
    Ze(t, e == null ? void 0 : e.productId) || t.listId && J((s) => s.includes((t == null ? void 0 : t.listId) ?? "") ? s.filter((d) => d !== t.listId) : [...s, (t == null ? void 0 : t.listId) ?? ""]);
  }, Y = (t) => {
    t.preventDefault(), i(!0);
  }, j = () => {
    ie.createList(I).then((t) => {
      var s;
      if (k)
        pe.push(`${Me.LIST}/${t == null ? void 0 : t.listId}`), x(
          {
            theme: G.SUCCESS,
            rightSeperator: !1,
            content: f,
            clickIcon: "times",
            icon: "check-circle",
            timeOut: W
          },
          R
        );
      else {
        const d = (s = r.lists) == null ? void 0 : s.concat(t);
        t.listId && J([...v, t.listId]), Q((C) => ({
          ...C,
          lists: d
        })), i(!1);
      }
    }).catch((...t) => {
      t[0].responseBody.detail === yt.ListMaxLimitExceeded ? (x(
        {
          theme: G.RED,
          rightSeperator: !1,
          content: Se,
          subtext: N,
          clickIcon: "times",
          icon: "exclamation-square",
          timeOut: W
        },
        R
      ), m == null || m()) : o(t);
    });
  }, ue = () => {
    var t, s, d;
    return ((t = I == null ? void 0 : I.name) == null ? void 0 : t.length) > 0 && ((s = I == null ? void 0 : I.description) == null ? void 0 : s.length) > 0 && (z() ? ((d = I.category) == null ? void 0 : d.length) > 0 : !0);
  }, D = (t) => {
    var s, d, C;
    return (s = e == null ? void 0 : e.productFlags) != null && s.restrictFromSharing && t.listType === Ae.Shareable ? !0 : !!((C = (d = t.payLoad) == null ? void 0 : d.entries) != null && C.find(({ product: c }) => c.id === (e == null ? void 0 : e.productId)));
  }, ee = () => S ? /* @__PURE__ */ a(st, { className: H["create-list-footer-button-loader"] }) : Z ? /* @__PURE__ */ a(Ut, { className: H["create-list-footer-button-confirm-loader"] }) : /* @__PURE__ */ a(
    Ve,
    {
      "data-testid": "confirm-lists",
      "data-pod-name": "cart",
      title: h("cart.addToListdrawer.confirm"),
      buttonWidth: Re.FULL_WIDTH,
      onClick: k ? u : w,
      disabled: k ? !1 : v.length === 0
    }
  ), he = () => l ? /* @__PURE__ */ b("div", { className: H["create-list-footer-button"], children: [
    !k && /* @__PURE__ */ a(
      Ve,
      {
        "data-testid": "create-list-cancel-btn",
        "data-pod-name": "cart",
        title: h("cart.addToListdrawer.cancel"),
        buttonStyle: ot.OUTLINE,
        buttonWidth: Re.FULL_WIDTH,
        onClick: () => i(!1)
      }
    ),
    /* @__PURE__ */ a(
      Ve,
      {
        disabled: !ue(),
        "data-testid": "create-list-button",
        "data-pod-name": "cart",
        title: h(k ? "cart.addToListdrawer.confirm" : "cart.addToListdrawer.save"),
        buttonWidth: Re.FULL_WIDTH,
        onClick: j
      }
    )
  ] }) : ee(), Be = (t) => {
    const s = t.listType === Ae.Private;
    return /* @__PURE__ */ b("div", { className: H["list-privacy"], children: [
      /* @__PURE__ */ a(ze, { iconName: s ? "eye-slash" : "eye" }),
      h(s ? "cart.list.private" : "cart.list.shareable")
    ] });
  }, Oe = () => e ? S ? /* @__PURE__ */ a(Nt, {}) : /* @__PURE__ */ a(
    $t,
    {
      link: e == null ? void 0 : e.mainLink,
      alt: e == null ? void 0 : e.alt,
      brandName: e == null ? void 0 : e.brandName,
      productName: e == null ? void 0 : e.productName,
      productId: e == null ? void 0 : e.productId,
      productSize: e == null ? void 0 : e.productSize,
      productPrice: e == null ? void 0 : e.productPrice,
      pointValue: e == null ? void 0 : e.pointValue,
      businessVolume: bt() ? "" : e == null ? void 0 : e.businessVolume
    }
  ) : /* @__PURE__ */ a(xe, {});
  return /* @__PURE__ */ b(
    It,
    {
      footer: he(),
      header: h(k ? "cart.addToListdrawer.addListToMyShop" : "cart.addToListdrawer.addToList"),
      closeIcon: !0,
      closeOnBackdropClick: !0,
      onClose: m,
      bottomGap: 0,
      useReactPortal: !0,
      portalContainerId: "react-portal-drawer",
      children: [
        Oe(),
        se && /* @__PURE__ */ a(ya, { isListDrawer: !0 }),
        l ? /* @__PURE__ */ a(vt, { onListDataChange: (t) => Te(t) }) : /* @__PURE__ */ b(xe, { children: [
          S ? /* @__PURE__ */ a(Ht, {}) : /* @__PURE__ */ b("div", { className: H[k ? "list-container-myShop" : "list-container"], children: [
            /* @__PURE__ */ b("div", { className: H["list-container-title"], children: [
              /* @__PURE__ */ a("span", { children: h("cart.addToListdrawer.lists") }),
              /* @__PURE__ */ a("div", { className: H["list-container-title-newList"], children: /* @__PURE__ */ a(
                at,
                {
                  scroll: !1,
                  onClick: Y,
                  text: h("cart.addToListdrawer.createNewList"),
                  theme: wt.PURPLE,
                  textLinkStyle: rt.UNDERLINE
                }
              ) })
            ] }),
            ($e = r == null ? void 0 : r.lists) == null ? void 0 : $e.map((t, s) => {
              var C, c, U, P, fe;
              const d = s === (((C = r == null ? void 0 : r.lists) == null ? void 0 : C.length) ?? 0) - 1;
              return t.listType === Ae.Wishlist && k ? null : /* @__PURE__ */ a(
                "div",
                {
                  className: H["list-container-cardCheckbox"],
                  ref: d ? me : void 0,
                  children: /* @__PURE__ */ a(
                    Vt,
                    {
                      imageShadows: !0,
                      imgSrc: ((P = (U = (c = t.payLoad) == null ? void 0 : c.entries) == null ? void 0 : U[0]) == null ? void 0 : P.product.cartIconPublicUrl) ?? `${ye}/icons/EmptyList.svg`,
                      id: `List${s}`,
                      text: (fe = t.payLoad) == null ? void 0 : fe.name,
                      subText: k ? Be(t) : "",
                      disabled: D(t),
                      checked: Ze(t, e == null ? void 0 : e.productId) || Array.isArray(v) && v.includes(t.listId),
                      onChange: () => B(t)
                    }
                  )
                },
                t.listId
              );
            })
          ] }),
          k && /* @__PURE__ */ b("div", { className: H["list-container-myShop-private-text"], children: [
            /* @__PURE__ */ a(ze, { iconName: "eye-slash" }),
            /* @__PURE__ */ a("p", { "data-testid": "visitorPrivate", "data-pod-name": "cart", children: h("cart.myshop.visitorPrivate") })
          ] })
        ] })
      ]
    }
  );
}, Za = "#ffffff", Da = "#396e75", er = "#e5fdff", tr = "#546223", ar = "#f0fae5", rr = "#a65523", or = "#fff1e8", ir = "#7f3e3e", sr = "#ffe2e2", nr = "#62625a", cr = "#f8f8e7", lr = "#38539a", dr = "#707070", mr = "#c8f8d1", ur = "#87c9c8", hr = "#5291b1", fr = "rgba(82, 145, 177, 0.1019607843)", gr = "#445685", Cr = "#181d61", pr = "rgba(24, 29, 97, 0.1019607843)", br = "#5969d6", yr = "#ea999d", Tr = "#b6577e", kr = "rgba(182, 87, 126, 0.1019607843)", Sr = "#7e3e80", _r = "#1e247f", Lr = "rgba(30, 36, 127, 0.1019607843)", Ir = "#da7600", wr = "#107f47", Vr = "#d91734", xr = "_html_ehcft_46", we = {
  amwayWhite: Za,
  darkBlue: Da,
  lightBlue: er,
  darkGreen: tr,
  lightGreen: ar,
  darkOrange: rr,
  lightOrange: or,
  darkRed: ir,
  lightRed: sr,
  darkYellow: nr,
  lightYellow: cr,
  darkPurple: lr,
  darkGrayOnWhite: dr,
  dataVizColor1: mr,
  dataVizColor2: ur,
  dataVizColor3: hr,
  dataVizColor3Background: fr,
  dataVizColor4: gr,
  dataVizColor5: Cr,
  dataVizColor5Background: pr,
  dataVizColor6: br,
  dataVizColor7: yr,
  dataVizColor8: Tr,
  dataVizColor8Background: kr,
  dataVizColor9: Sr,
  dataVizColor10: _r,
  dataVizColor10Background: Lr,
  dataVizAlertOrange: Ir,
  dataVizSuccessGreen: wr,
  dataVizWarningRed: Vr,
  "no-visible": "_no-visible_ehcft_42",
  html: xr,
  "ellipsis-menu-container": "_ellipsis-menu-container_ehcft_80",
  "ellipsis-menu": "_ellipsis-menu_ehcft_80",
  "commerce-gco-delete-modal": "_commerce-gco-delete-modal_ehcft_103",
  "commerce-gco-delete-modal-buttons": "_commerce-gco-delete-modal-buttons_ehcft_106",
  "skeleton-loading": "_skeleton-loading_ehcft_1"
}, zr = ({ currentCartId: m, isNonGCO: A, cartEntriesDetails: k }) => {
  var Xe;
  const e = Fe(), { updateAddress: se } = it(), { isRegistered: K, isAnonymous: X, isEmployee: $ } = tt(), [h, ne] = g([]), [pe, z] = g(!1), [be, ce] = g(!1), [ye, l] = g(!1), [i, r] = g(!1), [Q, I] = g(!1), [Te, v] = g(!1), [J, S] = g(!1), [ke, Z] = g(!1), q = e("cart.clearCart.warningText"), E = je(), _ = Ye(), { createToast: F, deleteToast: x } = Ke("cartEllipisMenu"), R = (Xe = _.params) == null ? void 0 : Xe.cartId, Se = We((n) => n.commerceCart), { cart: f } = Se, { myList: N } = We((n) => n.commerceMyList), L = ve(f, m), le = (L == null ? void 0 : L.sopMetaData) !== void 0 && L.sopMetaData.length !== 0, de = e("cart.cartEllipsisMenu.cartReassiged"), me = e("cart.cartEllipsisMenu.cartDeleted"), o = e("cart.groupOrder.button.cancel"), u = e("cart.addToCartDrawer.placeHolderText"), w = e("cart.cartEllipsisMenu.cartDuplicate"), B = e("cart.cartEllipsis.ProductsAddedToWishlist"), Y = e("cart.itemsUnavailable.cannotDuplicateSOPItems"), j = e("cart.itemsUnavailable.cannotReassignSOPItems"), [ue, D] = g(""), ee = nt(), he = () => {
    z(!0), r(!1), _e.clearCartEntries({
      cartId: O.getLocalStorage().retrieve(M.CartId),
      subCartId: m
    }).then((n) => {
      z(!1), S(!1), E(Ce(n)), Le.publishEvent({
        event: oe.UpdateCartEntryQty,
        payload: {
          cart: n,
          cartId: O.getLocalStorage().retrieve(M.CartId)
        },
        sync: !0
      });
    });
  }, Be = () => {
    l(!1), z(!0);
    const n = f.subCarts.find(({ subCartId: p }) => p === m);
    _e.deleteSubCart({
      cartId: O.getLocalStorage().retrieve(M.CartId),
      subCartId: m,
      options: {
        skipCartIdStoreInLS: !0,
        skipCartResStoreInLS: !0,
        skipVersionStoreInLS: !0
      }
    }).then(() => {
      var y, V, te;
      const p = O.getLocalStorage().retrieve("checkoutProfile");
      ((y = p == null ? void 0 : p.fulfillmentType.serviceLevel.deliveryAddress) == null ? void 0 : y.ownerId) === ((V = n == null ? void 0 : n.amwayUser) == null ? void 0 : V.amwayUserId) && Ue(f.amwayUser.amwayUserId, f.amwayUser.accountId).then(se), z(!1), F(
        {
          theme: G.SUCCESS,
          rightSeperator: !1,
          content: me,
          clickIcon: "times",
          icon: "check-circle",
          timeOut: W
        },
        x
      ), Le.publishEvent({
        event: oe.RemoveCartEntry,
        payload: {
          cartId: O.getLocalStorage().retrieve(M.CartId),
          cart_type: ""
        }
      }), R ? (te = _ == null ? void 0 : _.push) == null || te.call(_, Me.CART) : _e.getSubCart({
        cartId: f.id,
        subCartId: f.id,
        projections: Pe.DETAILED,
        options: {
          skipCartResStoreInLS: !0
        }
      }).then((ae) => {
        E(Ce(ae)), Le.publishEvent({
          event: oe.UpdateMiniCartIcon,
          payload: {
            cartId: O.getLocalStorage().retrieve(M.CartId),
            cart: ae,
            cart_type: ""
          }
        });
      });
    });
  };
  function Oe(n) {
    const p = {
      amwayUser: n,
      orderType: re.Gco,
      version: Number(O.getLocalStorage().retrieve(M.CartReqVersion))
    };
    _e.reassignCart({
      cartId: O.getLocalStorage().retrieve(M.CartId),
      subCartId: m,
      payload: p
    }).then((y) => {
      F(
        {
          theme: G.SUCCESS,
          rightSeperator: !1,
          content: de,
          clickIcon: "times",
          icon: "check-circle",
          timeOut: W
        },
        x
      );
      const V = y.subCarts;
      ce(!1), Le.publishEvent({
        event: oe.RedirectToSubCart,
        payload: {
          cartId: V == null ? void 0 : V[(V == null ? void 0 : V.length) - 1].subCartId,
          cart_type: ""
        }
      }), E(Ce(y));
    });
  }
  function Ee(n) {
    var te;
    const p = (te = f.subCarts) == null ? void 0 : te.find(({ subCartId: ae }) => ae === m), y = He((p == null ? void 0 : p.entries) || [], {
      filterPromotion: !0,
      filterSOP: !1,
      filterIsAccountFeeProduct: !0,
      filterIsAccountKitProduct: !0,
      filterUnsellableProduct: !0,
      filterAuxiliaryProducts: !0
    }), V = At(y);
    _e.createSubCart({
      cartId: O.getLocalStorage().retrieve(M.CartId),
      payload: {
        amwayUser: n,
        entries: V,
        orderType: f.orderType,
        version: Number(O.getLocalStorage().retrieve(M.CartReqVersion))
      }
    }).then((ae) => {
      var Qe;
      const ge = ae.subCarts;
      I(!1), Le.publishEvent({
        event: oe.RedirectToSubCart,
        payload: {
          cartId: ge == null ? void 0 : ge[(ge == null ? void 0 : ge.length) - 1].subCartId,
          cart_type: ""
        }
      }), R && ((Qe = _ == null ? void 0 : _.push) == null || Qe.call(_, Me.CART)), F(
        {
          theme: G.SUCCESS,
          rightSeperator: !1,
          content: w,
          clickIcon: "times",
          icon: "check-circle",
          timeOut: W
        },
        x
      ), E(Ce(ae));
    });
  }
  function $e(n) {
    E(_t(Lt(n))), F(
      {
        theme: G.SUCCESS,
        rightSeperator: !1,
        content: B,
        clickIcon: "times",
        icon: "check-circle",
        timeOut: W
      },
      x
    );
  }
  function t() {
    var n;
    if (K() || $()) {
      const p = (n = f == null ? void 0 : f.subCarts) == null ? void 0 : n.find(({ subCartId: y }) => y === m);
      ie.addToList([
        {
          version: N.version,
          entries: He((p == null ? void 0 : p.entries) || [], {
            filterPromotion: !1,
            filterSOP: !1,
            filterIsAccountFeeProduct: !0,
            filterIsAccountKitProduct: !0,
            filterUnsellableProduct: !0,
            filterAuxiliaryProducts: !0
          }),
          listId: N == null ? void 0 : N.listId
        }
      ]).then((y) => {
        $e(y), E(Ge(y));
      }).catch((...y) => ee(y));
      return;
    }
    v(!0);
  }
  const s = {
    id: Ie.DELETE_CART,
    title: e("cart.cartEllipsesMenu.delete"),
    icon: "trash-can",
    onClick: () => {
      S(!1), l(!0);
    }
  }, d = {
    id: Ie.DUPLICATE_CART,
    title: e("cart.cartEllipsesMenu.duplicateCart"),
    icon: "copy",
    onClick: () => {
      S(!1), D(Y), le ? Z(!0) : I(!0);
    }
  }, C = {
    id: Ie.REASSIGN_CART,
    title: e("cart.cartEllipsesMenu.reassignCart"),
    icon: "user-magnifying-glass",
    onClick: () => {
      S(!1), D(j), le ? Z(!0) : ce(!0);
    }
  }, c = {
    id: Ie.CLEAR_CART,
    title: e("cart.clearCart.clear"),
    icon: "cart-xmark",
    onClick: () => {
      S(!1), r(!0);
    }
  }, U = {
    id: Ie.ADD_ALL_TO_LIST,
    title: e("cart.cartEllipsis.addAllToList"),
    icon: "heart",
    onClick: () => {
      S(!1), t();
    }
  }, P = [c], fe = [U, c], ct = [d, c], lt = [C, d, s], dt = [C, s], mt = () => {
    ie.getAllListByUser({
      projections: Pe.FULL
    }).then((n) => E(Ge(n))).catch((...n) => ee(n));
  };
  return et(() => {
    var y, V;
    let n;
    const p = (y = f == null ? void 0 : f.subCarts) == null ? void 0 : y.find(({ subCartId: te }) => te === m);
    A ? n = X() ? P : fe : Ne(m) ? n = ct : n = ((V = p == null ? void 0 : p.entries) == null ? void 0 : V.length) === 0 ? dt : lt, ne(n);
  }, [f, A, m]), /* @__PURE__ */ b(xe, { children: [
    ke && /* @__PURE__ */ a(
      Bt,
      {
        notAvailableEntries: [],
        allSOPEntries: L == null ? void 0 : L.sopMetaData,
        showRemoveSOPItemsModal: !0,
        onPrimaryBtnClick: () => Z(!1),
        sopHeadingText: ue
      }
    ),
    pe && /* @__PURE__ */ a(Pt, {}),
    St() ? /* @__PURE__ */ a(
      at,
      {
        text: e("cart.cartEllipsisMenu.edit"),
        onClick: () => S(!0),
        textLinkStyle: rt.UNDERLINE
      }
    ) : /* @__PURE__ */ a(ze, { onClick: () => S(!0), iconName: "ellipsis-vertical" }),
    /* @__PURE__ */ a("div", { className: we["ellipsis-menu-container"], children: J && /* @__PURE__ */ a(xt, { className: we["ellipsis-menu"], menuItems: h, onClose: () => S(!1) }) }),
    /* @__PURE__ */ b("div", { children: [
      be && /* @__PURE__ */ a(
        qe,
        {
          cartData: f,
          onPrimaryButtonClick: () => ce(!1),
          drawerHeaderTitle: e("cart.cartEllipsesMenu.reassignCart"),
          placeHolderText: u,
          primaryButtonText: o,
          secondaryButtonText: e("cart.cartEllipsesMenu.reassign"),
          onRadioChange: Oe
        }
      ),
      Q && /* @__PURE__ */ a(
        qe,
        {
          cartData: f,
          onPrimaryButtonClick: () => I(!1),
          drawerHeaderTitle: e("cart.cartEllipsesMenu.duplicateCart"),
          placeHolderText: u,
          primaryButtonText: o,
          secondaryButtonText: e("cart.addToCartDrawer.accountAddCart"),
          onRadioChange: Ee
        }
      ),
      ye && /* @__PURE__ */ a("div", { className: we["commerce-gco-delete-modal"], children: /* @__PURE__ */ a(
        zt,
        {
          closeIcon: !1,
          onClose: () => l(!1),
          headline: e("cart.cartEllipsesMenu.deleteCart"),
          primaryButtonLabel: "",
          children: /* @__PURE__ */ b("div", { className: we["commerce-gco-delete-modal-buttons"], children: [
            /* @__PURE__ */ a(Ve, { title: e("cart.cartEllipsesMenu.yesDelete"), onClick: Be }),
            /* @__PURE__ */ a(Ve, { buttonStyle: ot.OUTLINE, title: o, onClick: () => l(!1) })
          ] })
        }
      ) }),
      i && /* @__PURE__ */ a("div", { className: we["commerce-gco-delete-modal"], children: /* @__PURE__ */ a(
        Ot,
        {
          headLineText: e("cart.clearCart.clear"),
          description: q,
          primaryButtonLabel: e("cart.cartEllipsesMenu.yesClear"),
          secondaryButtonLabel: o,
          onPrimarySuccess: he,
          onSecondarySuccess: () => r(!1)
        }
      ) }),
      Te && /* @__PURE__ */ a(
        Ja,
        {
          heartIconFilledcb: () => mt(),
          onDrawerClose: () => v(!1),
          cartEntriesDetails: k
        }
      )
    ] })
  ] });
};
export {
  Ja as A,
  ya as C,
  zr as a
};
//# sourceMappingURL=CartEllipsisMenu-76b1628a.mjs.map
